import React, { useState } from "react";

// Map administradora name -> logo file in /public/bank-logos
const LOGO_MAP = {
  "Ademicon": "ademicon.png",
  "BB Consórcios": "bbconsorcios.png",
  "Banrisul": "banrisul.png",
  "Bradesco": "bradesco.png",
  "CNP Consórcio": "cnp_logo.png",
  "Caixa": "caixa.png",
  "Caixa XS5": "caixa.png",
  "Caoa": "caoa.png",
  "Disal": "disal.png",
  "Embracon": "embracon.png",
  "Gazin": "gazin.png",
  "HS Consórcios": "hsconsorcios.png",
  "Itaú": "itauconsorcio.png",
  "Itaú Auto": "itau-auto.png",
  "Itaú Motos": "itauconsorcio.png",
  "Magalu": "magalu.png",
  "MyCon": "mycon.png",
  "Porto Seguro": "portoseguro.png",
  "Primo Rossi": "primorossi.png",
  "Racon Consórcios": "racon.png",
  "Rodobens": "rodobens.png",
  "Santander": "santander.png",
  "Serello": "serello.png",
  "Servopa": "servopa.png",
  "Sicredi": "sicredi.png",
  "Spengler": "spengler.png",
  "Sponchiado": "sponchiado.png",
  "Tradição": "tradicao.png",
  "Volkswagen": "volkswagen.png",
  "Yamaha": "yamaha.png",
  "Zema": "zema.png",
  "Âncora": "ancora.png",
};

export default function AdminBadge({ name, size = "md" }) {
  const [broken, setBroken] = useState(false);
  const file = LOGO_MAP[name];

  if (file && !broken) {
    const box = size === "sm" ? "h-10 w-[120px] p-1.5" : "h-14 w-[150px] p-2";
    return (
      <div
        className={`${box} bg-white rounded-xl border border-slate-200 shadow-sm flex items-center justify-center`}
        title={name}
      >
        <img
          src={`/bank-logos/${file}`}
          alt={name}
          onError={() => setBroken(true)}
          className="max-h-full max-w-full object-contain"
          loading="lazy"
        />
      </div>
    );
  }

  // Fallback: elegant velvet-gold badge for administradoras without a logo file
  const pad = size === "sm" ? "px-3 py-1.5 text-[11px]" : "px-4 py-2 text-xs";
  return (
    <div
      className={`velvet-gold inline-flex items-center gap-2 rounded-lg font-extrabold uppercase tracking-wide ${pad}`}
      title={name}
    >
      <span className="dot inline-block h-2.5 w-2.5 rounded-full" />
      {name}
    </div>
  );
}
